var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-overlay",
    { attrs: { show: _vm.consultandoElBack } },
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c("header-programa", {
                attrs: { programa: _vm.solicitud?.programa },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.esEscritura
        ? _c(
            "b-row",
            { staticClass: "mt-5 mb-5" },
            [
              _c(
                "b-col",
                { staticStyle: { "text-align": "end" } },
                [
                  _c(
                    "b-button",
                    {
                      attrs: {
                        type: "button",
                        block: "",
                        variant: "primary",
                        disabled: !_vm.esEjecutable,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.ejecutarClasificador()
                        },
                      },
                    },
                    [
                      _c("span", {
                        domProps: {
                          textContent: _vm._s(
                            _vm.$t(
                              "apeironGwApp.resultadosClasificadorSnp.acciones.ejecutar"
                            )
                          ),
                        },
                      }),
                      _vm._v(" "),
                      _c("b-icon", {
                        staticClass: "icono",
                        attrs: { icon: "caret-right-square" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", {
        staticClass: "modal-body",
        domProps: { innerHTML: _vm._s(_vm.mensajeClasificacion) },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }